module.exports = __webpack_public_path__ + "img/view-compliance-active.1b508bc9.svg";